export const salonInfo = {
  name: "Aura Hair",
  tagline: "Kapsalon & Haarwerk Rotterdam",
  googleMapsUrl: "https://maps.google.com/?q=Samuel+Esmeijerplein+3,+3067+HP+Rotterdam",
  website: "aurahair.nl",
  description: {
    nl: "Welkom bij Aura Hair in Rotterdam! Dé specialist voor moderne herenkapsels, skin fades, klassiek knippen, baardverzorging en professionele haarwerken aan het Samuel Esmeijerplein 3.",
    en: "Welcome to Aura Hair in Rotterdam! The premier destination for precision haircuts, skin fades, classic cuts, beard sculpting, and customized hair systems at Samuel Esmeijerplein 3.",
    tr: "Rotterdam Samuel Esmeijerplein 3'teki salonumuz Aura Hair'e hoş geldiniz! Modern saç kesimleri, skin fade, geleneksel ustalık, sakal bakımı ve protez saç uzmanlığı."
  },
  currency: "€",
  currencyCode: "EUR",
  phone: "+31 10 314 0673",
  phoneRaw: "+31103140673",
  whatsapp: "+31 6 85 40 22 10",
  whatsappRaw: "31685402210",
  email: "info@aurahair.nl",
  address: {
    street: "Samuel Esmeijerplein 3",
    postalCode: "3067 HP",
    city: "Rotterdam",
    country: "Nederland",
    full: "Samuel Esmeijerplein 3, 3067 HP Rotterdam, Nederland"
  },
  paymentMethods: [
    { name: "PIN / Maestro / V PAY", popular: true },
    { name: "iDEAL", popular: true },
    { name: "Apple Pay / Google Pay", popular: true },
    { name: "Contant / Cash", popular: false }
  ],
  workingHours: [
    { dayKey: "monday", day: { nl: "Maandag", en: "Monday", tr: "Pazartesi" }, hours: "Gesloten", hoursTr: "Kapalı", hoursEn: "Closed", isOpen: false },
    { dayKey: "tuesday", day: { nl: "Dinsdag", en: "Tuesday", tr: "Salı" }, hours: "09:00 - 17:00", hoursTr: "09:00 - 17:00", hoursEn: "09:00 - 17:00", isOpen: true },
    { dayKey: "wednesday", day: { nl: "Woensdag", en: "Wednesday", tr: "Çarşamba" }, hours: "09:00 - 17:00", hoursTr: "09:00 - 17:00", hoursEn: "09:00 - 17:00", isOpen: true },
    { dayKey: "thursday", day: { nl: "Donderdag", en: "Thursday", tr: "Perşembe" }, hours: "09:00 - 17:00", hoursTr: "09:00 - 17:00", hoursEn: "09:00 - 17:00", isOpen: true },
    { dayKey: "friday", day: { nl: "Vrijdag", en: "Friday", tr: "Cuma" }, hours: "09:00 - 17:00", hoursTr: "09:00 - 17:00", hoursEn: "09:00 - 17:00", isOpen: true },
    { dayKey: "saturday", day: { nl: "Zaterdag", en: "Saturday", tr: "Cumartesi" }, hours: "09:00 - 17:00", hoursTr: "09:00 - 17:00", hoursEn: "09:00 - 17:00", isOpen: true },
    { dayKey: "sunday", day: { nl: "Zondag", en: "Sunday", tr: "Pazar" }, hours: "Gesloten", hoursTr: "Kapalı", hoursEn: "Closed", isOpen: false },
  ],
  stats: [
    { value: "10+", label: { nl: "Jaar Ervaring", en: "Years Mastery", tr: "Yıllık Ustalık" } },
    { value: "5.0", label: { nl: "Google Beoordeling", en: "Google Rating", tr: "Google Puanı" }, isRating: true },
    { value: "100%", label: { nl: "Tevredenheid", en: "Satisfaction", tr: "Memnuniyet" } },
    { value: "Rotterdam", label: { nl: "Samuel Esmeijerplein", en: "Rotterdam East", tr: "Rotterdam" } }
  ],
  socials: {
    instagram: "https://www.instagram.com/rotterdamaurahair/",
    facebook: "https://www.facebook.com/rotterdamaurahair/",
    tiktok: "https://www.tiktok.com/@rotterdamaurahair",
    youtube: "https://www.youtube.com/@rotterdamaurahair"
  }
};
